import type { NewBookV1 } from "@ilteducation/content-registry-types";
import type { Language } from "@ilteducation/content-ref-data-types";

const getLMGDefaultDescription = () =>
  // eslint-disable-next-line max-len
  '<p><span style="color: rgb(0, 0, 0);">Läromedelsguiden är en bearbetad version av ett läromedel. Varje läromedelsguide innehåller två parallella spår: ett på svenska och ett på ett annat språk. Läromedelsguiden följer samma rubrikindelning som läromedlet. Ljudet på svenska är en uppläsning av texten i läroboken, medan ljudet på det andra språket är en sammanfattning av det viktigaste innehållet. Begreppen förklaras och kommenteras för att skapa bättre förståelse och ge en tydligare bild av deras innebörd. Rubriker, faktarutor, instuderingsfrågor och andra kortare texter är direkt översatta från svenska, utan bearbetning.</span></p><p><span style="color: rgb(0, 0, 0);">Sammanfattningen och översättningen från svenskan till engelska är genomförda av personer med relevant expertis. Översättningen till andra språk är baserad på maskinöversättning från den engelska versionen.</span></p>';

export const getLMGBaseInfo = (title: string, language: Language, subscriptionTypes: string[]): Partial<NewBookV1> => ({
  title: `${title} - Läromedelsguide på ${language.language}`,
  originalTitle: `${title}`,
  description: getLMGDefaultDescription(),
  properties: {
    sentenceHighlighting: true,
    reflowable: true,
    isLaromedelGuide: true,
    pageProgressionDirection: 'ltr',
    pictureInPicture: [],
    additionalContent: {
      kahoot: false,
      teachingMaterial: true,
      externalMaterial: false,
    },
    frog: false,
    isEasyToRead: false,
    isFactBook: false,
    isTeachingMaterial: true,
    isSpeakingBook: false,
    isPictureBook: false,
    isBoardBook: false,
    isChapterBook: false,
    isShortStory: false,
    bookType: 'audio-book',
  },
  languages: {
    mainLanguage: 'sv',
    secondaryLanguage: `${language.languageCode}`,
    audio: ['sv'],
  },
  accessRules: {
    subscriptionType: [...subscriptionTypes],
    services: ['audio-aid', 'manabua'],
  },
});
